export enum EDeliveryAddressStep {
  CHOOSE_FOR = "CHOOSE_FOR",
  CHOOSE_CONTEXT = "CHOOSE_CONTEXT",
  CHOOSE_ADDRESS = "CHOOSE_ADDRESS",
  ContextStep = "context",
  IdentityStep = 0,
  CompanyStep = 1,
  AddressStep = 2,
  SignStep = 3,

  SummaryStep = 4,

  SendingStep = 5,
  SuccessStep = 6,
  ErrorStep = 7,
}
